module.exports = __webpack_public_path__ + "static/fonts/Montserrat500.0098f804.ttf";